import React from "react";

const Housekeeping = () => {
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      data-bbox="29 4.9 144 190.1"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="29 4.9 144 190.1"
      role="img"
      className="content-card__svg"
    >
      <g>
        <path
          d="M160.2,63.5L103,44c0,0,0-4,0-4c8.6-5.4,15.6-9.8,15.6-18.6c0-9.1-7.4-16.5-16.5-16.5s-16.5,7.4-16.5,16.5
	c0,1.5,1.2,2.6,2.6,2.6c1.5,0,2.6-1.2,2.6-2.6c0-6.2,5-11.2,11.2-11.2c6.2,0,11.2,5,11.2,11.2c0,5.6-4.4,8.7-13.3,14.3
	c-0.2,0.1-2,1.3-2,3.3v5L42,64c-8.3,2.8-13,7.4-13,14c0,8.1,6.9,14.8,15,15v81h16v21h94V93l4,0c8.2,0,15-5.8,15-14
	C173,72.4,168.4,66.3,160.2,63.5z M49,169v-11h74v11H49z M149,88h-21v-1.7c0-5.4,4-11.3,9-11.3c0.3,0,1.7,0,2,0
	c5.8,0,10,5.5,10,11.3V88z M123,86.3v1.6v5.3V153H49V86c0-7.4,3.4-11,11-11h67.8C124.8,77,123,82.2,123,86.3z M149,190H65v-16h63V93
	h21V190z M158,88l-4,0v-2c0-8.7-7-16-16-16c-0.6,0-78.2,0-78.2,0C49.8,70,44,75,44,86v2c-5.2-0.2-10-4.8-10-10
	c0-4.3,3.2-7.4,9.4-9.5L100,48h1l57.5,20.5c6.1,2.1,9.5,6.2,9.5,10.5C168,84.3,163.3,88,158,88z"
        ></path>
      </g>
    </svg>
  );
};

export default Housekeeping;
